/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M56.87 116.241C22.749 116.241 0 91.701 0 62.661 0 32.477 22.748 9 58.016 9s56.871 23.477 58.017 53.661c0 29.04-22.749 53.58-59.162 53.58zM3.356 158.696h109.24v345.118H3.356V158.696zm171.84 0h94.43l5.727 48.017h2.292c13.665-22.332 48.933-55.87 108.095-55.87 72.827 0 126.261 46.954 126.261 148.469v204.502H402.677V312.809c0-44.745-15.956-74.848-55.725-74.848-29.622 0-47.788 20.123-55.807 40.164-3.437 6.708-3.437 16.77-3.437 26.83v198.777H177.486V269.291c0-43.6-1.228-79.347-2.291-110.595z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconLinkedIn = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconLinkedIn.defaultProps = {
  theme,
};
IconLinkedIn.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconLinkedIn.displayName = 'IconLinkedIn';
export { IconLinkedIn };
